import styled, { css } from 'styled-components';

const positionProps = ({ styledPosition = [] }) => css`
  top: ${styledPosition[0] || '0'};
  right: ${styledPosition[1] || '0'};
`;

const StyledFloatingButton = styled.div`
  position: absolute;
  ${positionProps}
  transform: translate(50%, -50%);
  display: none;
`;

export default StyledFloatingButton;
